import { render, staticRenderFns } from "./study-consent-type-section.vue?vue&type=template&id=6863a99d&scoped=true&"
import script from "./study-consent-type-section.vue?vue&type=script&lang=js&"
export * from "./study-consent-type-section.vue?vue&type=script&lang=js&"
import style0 from "./study-consent-type-section.vue?vue&type=style&index=0&id=6863a99d&lang=scss&scoped=true&"
import style1 from "./study-consent-type-section.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6863a99d",
  null
  
)

component.options.__file = "study-consent-type-section.vue"
export default component.exports